
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/blockchain-software-development",
      function () {
        return require("private-next-pages/services/blockchain-software-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/blockchain-software-development"])
      });
    }
  